import { waitSeconds } from "@reflact/tsutil";
import { Subject } from "rxjs";

export class TypeWriter {

  private _targetStr: string = "";
  private _currStr: string = "";

  public onFinish: Subject<boolean> = new Subject<boolean>();

  constructor(private opts: { characterMillies: number, clearOnFinish: boolean } = { characterMillies: 100, clearOnFinish: false }) {
  }


  public get currStr() {
    return this._currStr;
  }

  public set targetStr(str: string) {
    this._currStr = "";
    this._targetStr = str + "    ";
    void this.executionLoop();
  }
  public destroy() {
    this._currStr = "";
    this._targetStr = "";
  }

  public async executionLoop() {
    if (this._currStr == this._targetStr && this._targetStr == "") {
      return;
    }
    if (this._currStr == this._targetStr) {
      if (this.opts.clearOnFinish) {
        this._currStr = "";
        this._targetStr = "";
      }
      this.onFinish.next(true);
      return;
    }
    this._currStr += this._targetStr.substring(this._currStr.length, this._currStr.length + 1);
    await waitSeconds(this.opts.characterMillies / 1000);
    void this.executionLoop();
  }



}